export const formatSourceName = (name) => {
    switch (name) {
        case 'Wall Street Journal':
            return 'Wall Street Journal/ Dow Jones';
        default:
            return name;
    }
}
